var map = {
	"./arnolfini-portrait/hero-large.jpg": 8818,
	"./girl-with-a-pearl-earring/hero-large.jpg": 6196,
	"./guernica/hero-large.jpg": 8299,
	"./lady-with-an-ermine/hero-large.jpg": 9801,
	"./mona-lisa/hero-large.jpg": 3233,
	"./penitent-magdalene/hero-large.jpg": 4181,
	"./starry-night/hero-large.jpg": 6430,
	"./the-basket-of-apples/hero-large.jpg": 7257,
	"./the-boy-in-the-red-vest/hero-large.jpg": 9866,
	"./the-great-wave-off-kanagawa/hero-large.jpg": 6070,
	"./the-night-cafe/hero-large.jpg": 3434,
	"./the-sleeping-gypsy/hero-large.jpg": 5094,
	"./the-storm-on-the-sea-of-galilee/hero-large.jpg": 2610,
	"./the-swing/hero-large.jpg": 9800,
	"./van-gogh-self-portrait/hero-large.jpg": 7088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4215;